import React from 'react';
import { FieldDiamond } from './FieldDiamond';
type Page = {
  src: string;
  alt: string;
  caption: string;
};

/**
 * "Peek inside" — páginas REALES del producto (Volume 5 en Gamma), para que
 * la sales page muestre el pack tal cual está construido.
 * Las URLs apuntan a los assets del Gamma; si alguna no carga, se oculta y la
 * card queda con el diamante de tiza de fondo (fallback, sin ícono roto).
 */
const pages: Page[] = [{
  src: 'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/wfc1J8pr27oW05hP.jpg',
  alt: 'Volume cover: chalk diamond on green with the volume title in scoreboard gold',
  caption: 'Every volume, cover to field card'
}, {
  src: 'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/zNu1IvIQgxzvMxFk.jpg',
  alt: 'A timed ready-to-run practice sheet with color-coded blocks and stopwatch times',
  caption: 'A timed practice sheet you print and run'
}, {
  src: 'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/u1jG7LLtr7oDRHhc.jpg',
  alt: 'A drill card with a top-down field diagram, reps, scoring and a Rookie/Ready/Rising ladder',
  caption: 'Drill cards with diagrams, reps and scoring'
}, {
  src: 'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/Qg0iruOqF7C7VKtL.jpg',
  alt: 'A so-no vs so-yes slide showing right and wrong throws on the diamond',
  caption: '“Where the throw should go” — so no vs. so yes'
}, {
  src: 'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/NbNHW8Nd3Ef9NHXV.jpg',
  alt: 'A printable worksheet / dugout card with fill-in lines and a blank diamond',
  caption: 'Printable worksheets for game day'
}];
export function LookInside() {
  return <section aria-labelledby="peek-heading" className="w-full bg-ice" data-id="element-140" data-mp="3sg5g3wjs0mgm">
      <div className="max-w-6xl mx-auto px-5 pt-16 sm:pt-20" data-id="element-141" data-mp="3seug87tgbyus">
        <div className="text-center" data-id="element-142" data-mp="34pi5v4me1kqw">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-143" data-mp="2zrzwjd4gl3id">
            A peek inside
          </p>
          <h2 id="peek-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-144" data-mp="13pn0b771aiy3">
            Real pages from the pack
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-145" data-mp="1dfy5ex2gey6k">
            Not blank templates — every page is drawn, diagrammed and ready to
            print. Here’s a look at Volume 5.
          </p>
        </div>

        <div className="relative mt-9" data-id="element-146" data-mp="kru1afzj6t5z">
          <FieldDiamond className="pointer-events-none absolute -left-10 -top-6 hidden h-40 w-40 text-ink/[0.06] lg:block" data-id="element-147" data-mp="pokd2r4az2ll" />
          <ul className="flex snap-x snap-mandatory gap-4 overflow-x-auto pb-5 [scrollbar-width:thin]" data-id="element-148" data-mp="tpmcb7y7zenk">
            {pages.map(page => <li key={page.src} className="snap-start shrink-0 basis-[200px] sm:basis-[232px]" data-id="element-149" data-mp="ynnzo52oi04u">
                <figure className="clip-corner overflow-hidden rounded-2xl border border-ice-dark bg-white shadow-card" data-id="element-150" data-mp="2a44fw0m24ksr">
                  <div className="relative flex aspect-[9/16] w-full items-center justify-center overflow-hidden bg-navy-mid" data-id="element-151" data-mp="2k7jajwot3z14">
                    <FieldDiamond className="pointer-events-none absolute h-24 w-24 text-ice/15" data-id="element-152" data-mp="2fbuew4fwr2a3" />
                    <img src={page.src} alt={page.alt} loading="lazy" onError={e => {
                  e.currentTarget.style.display = 'none';
                }} className="absolute inset-0 h-full w-full object-cover object-top" data-id="element-153" data-mp="2agyas5xecogm" />
                  </div>
                  <figcaption className="px-3.5 py-3 text-[12.5px] font-medium leading-snug text-ink" data-id="element-154" data-mp="1rm9mkuxv6so5">
                    {page.caption}
                  </figcaption>
                </figure>
              </li>)}
          </ul>
          <p className="chalk-note mt-1 text-center text-xl text-ink-soft" data-id="element-155" data-mp="3hw35a710v81m">
            37 practices · 78 drill cards · 29 worksheets across the six volumes
          </p>
        </div>
      </div>
    </section>;
}